import { inject, Injectable, Signal, signal } from '@angular/core';
import { ReadonlyRepositoryCollectionService } from '@softline/core';
import { DocumentTypesRepository } from '../repositories/document-types.repository';
import { DocumentType } from '../types/document-type';

@Injectable()
export class DocumentTypesService extends ReadonlyRepositoryCollectionService<
  DocumentType,
  DocumentType[],
  undefined
> {
  override readonly params: Signal<undefined> = signal(undefined);

  constructor() {
    super(inject(DocumentTypesRepository));
  }

  protected override getAll(result: DocumentType[] | null | undefined): DocumentType[] {
    return result ?? [];
  }
}
